import React, { useState } from 'react';

const EXPECTED = {
  firstName: 'Marcus',
  lastName: 'Reeves',
  email: 'marcus.reeves@techcorp.io',
  phone: '+1-415-882-0934',
  department: 'Engineering',
  message: 'Requesting access to the internal dashboard for Q2 reporting.',
};

const DEPARTMENTS = ['Select...', 'Engineering', 'Marketing', 'Finance', 'HR', 'Operations', 'Legal'];

function Field({ label, name, type = 'text', placeholder, value, onChange, error, disabled }) {
  return (
    <div className="ab-field">
      <label className="ab-label">{label}</label>
      <input name={name} type={type} value={value} onChange={onChange}
        className={`ab-input${error ? ' ab-input-err' : ''}`} placeholder={placeholder} disabled={disabled} />
      {error && <span className="ab-field-err">{error}</span>}
    </div>
  );
}

export default function C01_ContactForm({ onComplete }) {
  const [form, setForm] = useState({ firstName: '', lastName: '', email: '', phone: '', department: 'Select...', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  const ch = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const validate = () => {
    const errs = {};
    if (!form.firstName.trim()) errs.firstName = 'Required';
    if (!form.lastName.trim()) errs.lastName = 'Required';
    if (!form.email.trim()) errs.email = 'Required';
    if (!form.phone.trim()) errs.phone = 'Required';
    if (form.department === 'Select...') errs.department = 'Select a department';
    if (!form.message.trim()) errs.message = 'Required';
    return errs;
  };

  const handleSubmit = () => {
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setSubmitted(true);
    const results = {};
    let score = 0;
    for (const key of Object.keys(EXPECTED)) {
      const got = form[key]?.trim();
      const exp = EXPECTED[key];
      const pass = got === exp;
      results[key] = { expected: exp, got, pass };
      if (pass) score++;
    }
    const pct = Math.round((score / Object.keys(EXPECTED).length) * 100);
    onComplete({ score: pct, details: results, passed: pct === 100 });
  };

  return (
    <div className="ab-challenge-ui">
      <div className="ab-form-grid-2">
        <Field label="First Name" name="firstName" placeholder="Enter first name" value={form.firstName} onChange={ch} error={errors.firstName} disabled={submitted} />
        <Field label="Last Name" name="lastName" placeholder="Enter last name" value={form.lastName} onChange={ch} error={errors.lastName} disabled={submitted} />
        <Field label="Email Address" name="email" type="email" placeholder="Enter email" value={form.email} onChange={ch} error={errors.email} disabled={submitted} />
        <Field label="Phone Number" name="phone" placeholder="Enter phone number" value={form.phone} onChange={ch} error={errors.phone} disabled={submitted} />
      </div>
      <div className="ab-field">
        <label className="ab-label">Department</label>
        <select name="department" value={form.department} onChange={ch}
          className={`ab-input${errors.department ? ' ab-input-err' : ''}`} disabled={submitted}>
          {DEPARTMENTS.map(d => <option key={d}>{d}</option>)}
        </select>
        {errors.department && <span className="ab-field-err">{errors.department}</span>}
      </div>
      <div className="ab-field">
        <label className="ab-label">Message</label>
        <textarea name="message" value={form.message} onChange={ch} rows={3}
          className={`ab-input ab-textarea${errors.message ? ' ab-input-err' : ''}`}
          placeholder="Enter your message" disabled={submitted} />
        {errors.message && <span className="ab-field-err">{errors.message}</span>}
      </div>
      {!submitted && (
        <button className="ab-action-btn" onClick={handleSubmit}>Submit</button>
      )}
      {submitted && <div className="ab-submitted-badge">✓ Form Submitted — Evaluating...</div>}
    </div>
  );
}
